import React from 'react';
import { Typography, InputNumber } from 'antd';
import { CustomTooltip } from './custom-tooltip';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';

const { Text } = Typography;

interface NumberFieldProps {
  field: any;
  value: number | undefined;
  onChange: (value: number | null) => void;
  onBlur?: () => void;
  commonStyle: React.CSSProperties;
  labelStyle: React.CSSProperties;
  error?: string;
}

export const NumberField: React.FC<NumberFieldProps> = ({
  field,
  value,
  onChange,
  onBlur,
  commonStyle,
  labelStyle,
  error
}) => {
  const { fontSize } = useResponsiveSizes();

  const handleChange = (val: number | null) => {
    onChange(val);
  };

  return (
    <div style={commonStyle}>
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase' }}>
        {field.label}
      </Text>
      <CustomTooltip field={field}>
        <InputNumber
          placeholder={field.placeholder}
          style={{
            fontSize: fontSize.base,
            width: '100%'
          }}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          status={error ? 'error' : undefined}
          min={field.min ?? 1}
          max={field.max}
          precision={0}
          controls={true}
        />
      </CustomTooltip>
      {field.description && !error && (
        <Text type='secondary' style={{ fontSize: fontSize.sm, marginTop: 4 }}>
          {field.description}
        </Text>
      )}
      {error && (
        <Text type='danger' style={{ fontSize: fontSize.sm, marginTop: 4 }}>
          {error}
        </Text>
      )}
    </div>
  );
};
